import { render } from "./StudentEnrollSuccess.vue?vue&type=template&id=20e0e73c&scoped=true"
import script from "./StudentEnrollSuccess.vue?vue&type=script&lang=js"
export * from "./StudentEnrollSuccess.vue?vue&type=script&lang=js"

import "./StudentEnrollSuccess.vue?vue&type=style&index=0&id=20e0e73c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e0e73c"]])

export default __exports__